<template>
  <b-container fluid>
    <b-row>
      <b-col id="shipping-form">
        <form @submit.stop.prevent="postShipping" v-if="success === 0 && errors.length === 0">
          <b-row>
            <div class="form-group col-12">
              <label for="reference" v-translate>Company</label>
              <company-autocomplete v-if="!company" ref="companyAc" @selected="onSearchCompanySelected" :includes="['applications']" />
              <p v-if="company">
                {{ company.name }} <b-badge variant="danger" href="#" @click.prevent="emitCancel">×</b-badge>
              </p>
            </div>
          </b-row>
          <b-row v-if="company">
            <div class="form-group col-sm-6">
              <label for="shipping-type" v-translate>Shipping Type</label>
              <div class="input-group">
                <b-form-select id="shipping-type" v-model="shipping.type" :options="shippingTypesSelect.map(option => {
                  return {
                    text: option.text,
                    value: option.text
                  }
                })" required></b-form-select>
              </div>
            </div>
            <div class="form-group col-sm-6">
              <label for="shipping-size" v-translate>Shipping Size</label>
              <div class="input-group">
                <b-form-select id="shipping-size" v-model="shipping.sizeId" :options="shippingSizesSelect" required></b-form-select>
              </div>
            </div>
            <b-card id="shipping-from">
              <h4><img src="../assets/img/ic_origen.svg" alt=""> <translate>Origin</translate></h4>
              <b-row>
                <div class="form-group col-sm-7">
                  <label for="from_extra" v-translate>Street and number</label>
                  <div class="input-group" v-if="!defaultShippingFields.googlePlaceString">
                    <address-autocomplete ref="addressAutocomplete" @selected="selectedItem" :minCharacter="4" :required="true" />
                  </div>
                  <p v-if="defaultShippingFields.googlePlaceString">
                    {{ defaultShippingFields.googlePlaceString }} <b-badge variant="danger" href="#" @click.prevent="defaultShippingFields.googlePlaceString = null; defaultShippingFields.placeId = null; defaultShippingFields.lat = null; defaultShippingFields.lng = null">×</b-badge>
                  </p>
                </div>
                <div class="form-group col-sm-4">
                  <label for="floor" v-translate>Floor, door, etc.</label>
                  <div class="input-group">
                    <b-form-input id="floor" v-model="defaultShippingFields.floor" />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="contact-name" v-translate>Contact First Name</label>
                  <div class="input-group">
                    <b-form-input id="contact-name" v-model="defaultShippingFields.contact.firstName" required />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="contact-lastname" v-translate>Contact Last Name</label>
                  <div class="input-group">
                    <b-form-input id="contact-lastname" v-model="defaultShippingFields.contact.lastName" />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="contact-email" v-translate>Contact Email</label>
                  <div class="input-group">
                    <b-form-input id="contact-email" type="email" v-model="defaultShippingFields.contact.email" />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="from_phone" v-translate>Contact Phone</label>
                  <div class="input-group">
                    <cleave :options="{ phone: true, phoneRegionCode: this.$cookies.get('country').toLowerCase() }" class="form-control" v-model="defaultShippingFields.contact.phone" autocomplete="nope"></cleave>
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="from-instructions" v-translate>Instructions on Origin</label>
                  <div class="input-group">
                    <b-form-textarea id="from-instructions" v-model="defaultShippingFields.instructions" />
                  </div>
                </div>
              </b-row>
            </b-card>

            <b-card id="shipping-to">
              <h4><img src="../assets/img/ic_destino.svg" alt=""> <translate>Destination</translate></h4>
              <b-row>
                <div class="form-group col-sm-7">
                  <label for="from_extra" v-translate>Street and number</label>
                  <div class="input-group" v-if="!shipping.to.placeId">
                    <address-autocomplete ref="addressAutocomplete" @selected="selectedTo" :minCharacter="4" :required="true" />
                  </div>
                  <p v-if="shipping.to.googlePlaceString">
                    {{ shipping.to.googlePlaceString }} <b-badge variant="danger" href="#" @click.prevent="shipping.to.googlePlaceString = null; shipping.to.placeId = null; shipping.to.lat = null; shipping.to.lng = null">×</b-badge>
                  </p>
                </div>
                <div class="form-group col-sm-4">
                  <label for="destination-floor" v-translate>Floor, door, etc.</label>
                  <div class="input-group">
                    <b-form-input id="destination-floor" v-model="shipping.to.floor" />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="destination-contact-name" v-translate>Contact First Name</label>
                  <div class="input-group">
                    <b-form-input id="destination-contact-name" v-model="shipping.to.contact.firstName" required />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="destination-contact-lastname" v-translate>Contact Last Name</label>
                  <div class="input-group">
                    <b-form-input id="destination-contact-lastname" v-model="shipping.to.contact.lastName" />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="destination-contact-email" v-translate>Contact Email</label>
                  <div class="input-group">
                    <b-form-input id="destination-contact-email" type="email" v-model="shipping.to.contact.email" />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="from_phone" v-translate>Contact Phone</label>
                  <div class="input-group">
                    <cleave :options="{ phone: true, phoneRegionCode: this.$cookies.get('country').toLowerCase() }" class="form-control" v-model="shipping.to.contact.phone" autocomplete="nope"></cleave>
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="to-instructions" v-translate>Instructions on Destination</label>
                  <div class="input-group">
                    <b-form-textarea id="to-instructions" v-model="shipping.to.instructions" />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="description" v-translate>Description</label>
                  <div class="input-group">
                    <b-form-textarea id="description" v-model="shipping.description" />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="external-code" v-translate>External Code</label>
                  <div class="input-group">
                    <b-form-input id="external-code" type="text" v-model="shipping.internalCode" />
                  </div>
                </div>
              </b-row>
            </b-card>
              <b-col cols="6">
                <label for="shipping-flow" v-translate>Shipping Flow</label>
                <div class="input-group">
                  <b-form-select id="shipping-flow" v-model="shipping.flow" :options="shippingFlowOptions" required></b-form-select>
                </div>
              </b-col>
              <b-col cols="6" v-if="shipping.flow === 'manual'">
                <label for="shipping-flow">&nbsp;</label>
                <b-form-checkbox
                  v-model="setAsReady"
                  name="checkbox-1"
                  :value="true"
                  :unchecked-value="false"
                >
                  <translate>Set as READY immediately</translate>
                </b-form-checkbox>
              </b-col>
            <div class="text-right form-group col-12 form-actions mt-4">
              <b-button type="submit" variant="primary" size="lg" v-translate>Post Shipping</b-button>
              <b-button type="button" variant="outline-primary" size="lg" @click.prevent="emitCancel" v-translate>Clear All</b-button>
            </div>
          </b-row>
        </form>
      </b-col>
      <b-col class="d-none d-md-block" id="shipping-map">
        <leaflet-map ref="fullMap" :fitAlways="true" :geolocate="false" style="height: 100%;" />
      </b-col>
    </b-row>
    <b-modal size="lg" id="modalFromPickPlace" ref="modalFromPickPlace" hide-footer hide-header @hide="$refs.pickFromPlaceMap.pickPlace(0, 0)">
      <place-picker ref="pickFromPlaceMap" hasReference @cancel="closeModalFromPickPlace" @placePicked="setPlacePickedFrom" centerMap fit-always :zoom="17" />
    </b-modal>
    <b-modal size="lg" id="modalToPickPlace" ref="modalToPickPlace" hide-footer hide-header @hide="$refs.pickToPlaceMap.pickPlace(0, 0)">
      <place-picker ref="pickToPlaceMap" hasReference @cancel="closeModalToPickPlace" @placePicked="setPlacePickedTo" centerMap fit-always :zoom="17" />
    </b-modal>
  </b-container>
</template>

<script>
import AddressMixins from '@/mixins/address.mixin.js'
import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'
import AddressAutocomplete from '@/components/autocompletes/AddressAutocomplete'
import Cleave from 'vue-cleave'
import LeafletMap from '@/components/LeafletMap'
import PlacePicker from '@/components/PlacePicker'
export default {
  name: 'CompanyNewShipping',
  components: {
    CompanyAutocomplete,
    AddressAutocomplete,
    Cleave,
    LeafletMap,
    PlacePicker
  },
  data() {
    return {
      shippingFlowOptions: [
        {
          text: 'Manual',
          value: 'manual'
        },
        {
          text: 'Automatic',
          value: 'automatic'
        }
      ],
      searchCompanyQuery: '',
      companyAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('Company Name, Business Name or TIN'),
        inputClass: 'form-control'
      },
      minCharacter: 2,
      company: null,
      apiCredentials: {},
      defaultShippingFields: {
        placeId: null,
        googlePlaceString: null,
        lat: null,
        lng: null,
        street: '',
        number: '',
        floor: '',
        apartment: '',
        city: '',
        state: '',
        postalCode: '',
        country: 'AR',
        instructions: '',
        contact: {
          firstName: '',
          lastName: '',
          email: '',
          phone: ''
        },
        message: ''
      },
      shipping: {
        scheduledDate: null,
        currency: 'ARS',
        type: 'regular',
        flow: 'manual',
        from: {
          placeId: '',
          street: '',
          number: null,
          floor: '',
          apartment: '',
          city: '',
          state: '',
          postalCode: '',
          country: 'AR',
          instructions: '',
          contact: {
            firstName: '',
            lastName: '',
            email: '',
            phone: ''
          },
          message: ''
        },
        to: {
          placeId: '',
          street: '',
          number: null,
          floor: '',
          apartment: '',
          city: '',
          state: '',
          postalCode: '',
          country: 'AR',
          instructions: '',
          contact: {
            firstName: '',
            lastName: '',
            email: '',
            phone: ''
          },
          message: '',
          googlePlaceString: '',
          lat: null,
          lng: null
        },
        internalCode: '',
        description: '',
        sizeId: 1,
        extra: {}
      },
      markers: [],
      success: 0,
      errors: [],
      setAsReady: false
    }
  },
  watch: {
    defaultShippingFields(val) {
      this.shipping.from = val
    }
  },
  mixins: [AddressMixins],
  created() {
    this.fetchShippingTypes()
    this.fetchShippingSizes()
  },
  methods: {
    postShipping() {
      if (this.apiCredentials && this.apiCredentials.active === 1) {
        let defaultShippingFields = {...this.defaultShippingFields}
        defaultShippingFields.instructions = ''
        this.$http.patch(this.$appConfig.api.baseUrl + 'companies/' + this.company.id, {default_shipping_fields: defaultShippingFields})
          .then(response => {
            this.$http.post(this.$appConfig.api.baseUrl + 'b2b/shippings?appId=' + this.apiCredentials.id, this.shipping, {before: this.changeAuth})
              .then(response => {
                this.resetDataTo()
                if (this.setAsReady) {
                  let params = {
                    shipping_id: response.body.id,
                    user_id: this.$store.getters.profile.id,
                    status: 'READY'
                  }
                  this.$http.post(this.$appConfig.api.baseUrl + 'status', params)
                    .then(response => {
                      this.openShipping(response.body.shipping_id)
                    })
                } else {
                  this.openShipping(response.body.id)
                }
              })
          })
      } else {
        alert(this.$gettext('The company has no active Applications to post via B2B'))
      }
    },
    autocompleteEndpoint(query) {
      if (query.length >= 3) {
        return this.$appConfig.api.baseUrl + 'autocomplete?query=' + query
      } else {
        return
      }
    },
    async selectedItem(item) {
      await this.checkPlace(item)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.setPlacePickedFrom(this.theCheckedAddress)
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalFromPickPlace.show()
          setTimeout(function () {
            this.$refs.pickFromPlaceMap.center = [
              this.theCheckedAddress.lat,
              this.theCheckedAddress.lng
            ]
            this.$refs.pickFromPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })
      this.defaultShippingFields.googlePlaceString = this.formattedDisplay(item)
    },
    setPlacePickedFrom(place) {
      this.defaultShippingFields.placeId = place.id
      this.defaultShippingFields.googlePlaceString = place.formatted_address
      this.defaultShippingFields.lat = place.lat
      this.defaultShippingFields.lng = place.lng

      this.shipping.from.placeId = place.id
      this.shipping.from.googlePlaceString = place.formatted_address
      this.shipping.from.lat = place.lat
      this.shipping.from.lng = place.lng

      const marker = {
        id: '0',
        lat: this.defaultShippingFields.lat,
        lng: this.defaultShippingFields.lng,
        icon: this.$appConfig.staticBaseUrl + 'static/img/ic_origin_on.svg',
        x: 10,
        y: 10,
        infoText: 'Origin',
        tooltip: true
      }
      const i = this.markers.findIndex(x => x.infoText === 'Origin')
      if (i === -1) {
        this.markers.push(marker)
      } else {
        this.markers[i] = marker
      }
      this.$refs.fullMap.addMarkers(this.markers)

      this.defaultShippingFields.instructions = place.reference ? place.reference + ' - ' + (this.defaultShippingFields.instructions || '') : this.defaultShippingFields.instructions
      this.$refs.modalFromPickPlace.hide()
    },
    closeModalFromPickPlace() {
      this.$refs.modalFromPickPlace.hide()
    },
    async selectedTo(item) {
      await this.checkPlace(item)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.setPlacePickedTo(this.theCheckedAddress)
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalToPickPlace.show()
          setTimeout(function () {
            this.$refs.pickToPlaceMap.center = [
              this.theCheckedAddress.lat,
              this.theCheckedAddress.lng
            ]
            this.$refs.pickToPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })
      this.shipping.to.googlePlaceString = this.formattedDisplay(item)
    },
    setPlacePickedTo(place) {
      this.shipping.to.placeId = place.id
      this.shipping.to.googlePlaceString = place.formatted_address
      this.shipping.to.lat = place.lat
      this.shipping.to.lng = place.lng

      const marker = {
        id: '1',
        lat: this.shipping.to.lat,
        lng: this.shipping.to.lng,
        icon: this.$appConfig.staticBaseUrl + 'static/img/ic_destination_on.svg',
        x: 10,
        y: 10,
        infoText: 'Destination',
        tooltip: true
      }
      const i = this.markers.findIndex(x => x.infoText === 'Destination')
      if (i === -1) {
        this.markers.push(marker)
      } else {
        this.markers[i] = marker
      }
      this.$refs.fullMap.addMarkers(this.markers)

      this.shipping.to.instructions = place.reference ? place.reference + ' - ' + (this.shipping.to.instructions || '') : this.shipping.to.instructions
      this.$refs.modalToPickPlace.hide()
    },
    closeModalToPickPlace() {
      this.$refs.modalToPickPlace.hide()
    },
    formattedDisplay(result) {
      return result.main_text + ', ' + result.secondary_text
    },
    emitCancel() {
      this.resetData()
      this.fetchShippingTypes()
      this.fetchShippingSizes()
      this.$emit('cancel')
    },
    emitSuccess() {
      this.$emit('success')
    },
    onCompanyInputChange(query) {
      let url = ''
      if (query.trim().length >= this.minCharacter) {
        let params = {
          params: {
            sort: [{
              key: 'created_at',
              direction: 'desc'
            }],
            filter_groups: [{
              or: true,
              filters: [
                ['name', 'ct', query.trim()],
                ['business_name', 'ct', query.trim()],
                ['tin', 'ct', query.trim()]
              ]
            }]
          }
        }

        url = this.$appConfig.api.baseUrl + 'companies?includes[]=applications'
        return new Promise(resolve => {
          this.$http.get(url, params).then(response => {
            const items = []
            response.body.data.forEach((item) => {
              items.push(item)
            })
            resolve(items)
          })
        })
      }
    },
    changeAuth(req) {
      return req.headers.set('Authorization', this.apiCredentials.key)
    },
    onSearchCompanySelected(item) {
      this.apiCredentials = item.applications.find(x => (x.platform_id === null || x.platform_id === 1) && x.active === 1)

      if (!this.apiCredentials) {
        alert(this.$gettext('ERROR: The company has no active Default Applications to post via B2B! Please add one before post a new Company Shipping.'))
      } else {
        this.company = {id: item.id, name: item.name}
        if (!item.default_shipping_fields || item.default_shipping_fields.length === 0) {
          this.defaultShippingFields.contact.firstName = item.contact_name
          this.defaultShippingFields.contact.email = item.email
          this.defaultShippingFields.contact.phone = item.phone
          this.defaultShippingFields.country = this.shipping.from.country = this.shipping.to.country = item.country_iso_code
        } else {
          this.defaultShippingFields = item.default_shipping_fields
          this.company.defaultShippingFields = item.default_shipping_fields
          this.company.defaultShippingFields.country = this.defaultShippingFields.country = this.shipping.from.country = this.shipping.to.country = item.country_iso_code
          if (item.default_shipping_fields.lat) {
            this.markers = []
            this.markers.push({
              id: '0',
              lat: item.default_shipping_fields.lat,
              lng: item.default_shipping_fields.lng,
              icon: this.$appConfig.staticBaseUrl + 'static/img/ic_origin_on.svg',
              x: 10,
              y: 10,
              infoText: 'Origin',
              tooltip: true
            })
            this.$refs.fullMap.addMarkers(this.markers)
          }
        }
        this.shipping.currency = window.countries.find(x => x.iso_code === item.country_iso_code).front_config.i18n.currency
        this.searchCompanyQuery = ''
      }
    },
    openShipping(id) {
      window.open('/edit/shippings/' + id, id)
    },
    resetDataTo: function () {
      Object.assign(this.$data.shipping.to, this.$options.data.call(this).shipping.to)
      this.shipping.description = ''
      this.shipping.internalCode = ''
      this.shipping.flow = 'manual'
    },
    resetData: function () {
      Object.assign(this.$data, this.$options.data.call(this))
    }
  }
}
</script>

<style lang="scss" scoped>
#shipping-form {
  position: fixed;
  top: 50px;
  left: 0;
  bottom: 0;
  background-color: #ecedef;
  padding: 40px;
  border-right: 1px solid #ddd;
  box-shadow: 0 0 15px rgba(0,0,0,.15);
  min-height: 100vh;
  width: 600px;
  z-index: 1001;
  overflow-y: auto;
  padding-bottom: 160px;
  .alert-warning {
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffc107;
    border-width: 0 0 0 5px;
    h5 {
      font-weight: 400;
    }
  }
  .card {
    h4 {
      text-transform: uppercase;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.6;
      img {
        position: relative;
        vertical-align: top;
      }

    }
  }
  #shipping-form-submit {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 600px;
    border-top: 1px solid #ddd;
    text-align: center;
    background: #fff;
    padding: 30px;
  }
}
#shipping-map {
  padding: 0;
  position: fixed;
  top: 50px;
  left: 600px;
  bottom: 0;
  right: 0;
  width: auto;
  z-index: 1000;
  > * {
    min-height: 100vh;
  }
  .vue-map-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: auto !important;
    height: auto !important;
  }
}
</style>
